import { render, staticRenderFns } from "./HistoryStatusReturn.vue?vue&type=template&id=44200588&scoped=true"
import script from "./HistoryStatusReturn.vue?vue&type=script&lang=js"
export * from "./HistoryStatusReturn.vue?vue&type=script&lang=js"
import style0 from "./HistoryStatusReturn.vue?vue&type=style&index=0&id=44200588&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44200588",
  null
  
)

export default component.exports